const Green = {
  Green: {
    _000: '#F0FDF4',
    _100: '#DCFCE7',
    _200: '#BBF7D0',
    _300: '#86EFAC',
    _400: '#4ADE80',
    _500: '#22C55E',
    _600: '#16A34A',
    _700: '#15803D',
    _800: '#166534',
    _900: '#14532D',
  },
};

export default Green;
